import Pet from "./Pet";

export default class PetBat extends Pet {
    constructor() {
        super("guardian_pet", Pet.TYPE_BAT);
    }

    init() {
        super.init(P3.utils.selectRandom(["pet2"]));
    }
}